import { connect } from 'react-redux';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import { TextConfirmationModal } from 'components';
import { createStructuredSelector } from 'reselect';
import { selectIsOpenTextConfirmationModal, selectTextConfirmationModalMetadata } from 'selectors/Common';
import { closeTextConfirmationModal } from 'actions/Common';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onHide: () => dispatch(closeTextConfirmationModal()),
});

type SelectedValues = {
  show: boolean,
  acceptMetadata: { [key: string]: any },
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  show: selectIsOpenTextConfirmationModal(),
  acceptMetadata: selectTextConfirmationModalMetadata(),
});

export default connect(mapStateToProps, mapDispatchToProps)(TextConfirmationModal);